// Preserve links to the catalogue experiment after merging it into its parent project.
export const canonicalProjectId = id => Number(id) === 8 ? 15 : Number(id);
